const footerYearContainer = document.querySelector('.js--footer-year-container');

footerYearContainer.textContent = new Date().getFullYear();
